import React from 'react';

// Brand mark uses the provided K9 image inside a soft amber circle.
// The image is naturally black on white; we invert it so it reads white on dark,
// then a CSS mask tints it to the brand amber on hover.
const KangoLogo = ({ className = 'w-10 h-10' }) => (
  <div
    className={`${className} relative rounded-full overflow-hidden flex items-center justify-center `}
    aria-label="Kango 9 School logo"
  >
    <img
      src={require('./images/K9.jpeg') }
      alt="K9"
      className=" object-contain select-none pointer-events-none"
      draggable={false}
    />
  </div>
);

export default KangoLogo;
